import { HttpService, MessageService, ModalService } from '@philips-emr/tws-core/lib/services';

import { Endpoint } from '../constants';

interface Term {
  dsTerm: string,
  nrSequence: number,
  type: string,
}

export default class TermsService {

  public static openTermModal(term: Term): void {
    let title = '';
    if (term) {
      title = term.type == 'TU' ? MessageService.translate('provider.terms-of-service')
        : MessageService.translate('provider.privacy-notice');
      ModalService.openDefault({
        id: 'term-modal',
        closeable: false,
        fragment: 'assing-term',
        title: title,
        contextData: { type: term.type },
      });
    }
  }

  public static checkTerms(): void {
    void HttpService.get<Term[]>(Endpoint.GET.TERMS).then((response) => {
      const terms = response.body;

      if (terms && terms.length > 0) {
        const term = terms.pop();
        if (term) {
          this.openTermModal(term);
        }
      }
    });
  }

}

export type {
  Term,
};
